/**
 * Окно видимости сезонов для списков (AK-790 re-land #673, UAT founder 05.08
 * баг 1): настройка компании «показывать N прошлых / M будущих» — одна, а
 * потребителей два (/planning и SeasonPicker в шапке). Здесь — общий фильтр,
 * чтобы селектор и тест держали ОДНУ формулу, а не две копии.
 */
export interface SeasonVisibilityWindow {
  past: number;
  future: number;
}

interface SeasonLike {
  code: string;
  year: number;
}

/**
 * Сезоны в порядке убывания года, ограниченные окном вокруг КАЛЕНДАРНОГО
 * года — так же считает `GET /planning/seasons` на бэке. Центрировать на
 * активном сезоне сессии нельзя: открыв 2020, человек сдвинул бы себе окно
 * и потерял из списка сегодняшний год.
 *
 * `activeCode` — сезон, выбранный в шапке. Если он вне окна (человек ушёл в
 * старую историю), он всё равно остаётся в списке: кнопка показывает сезон,
 * которого нет в выпадашке, — это тупик, из которого не вернуться.
 *
 * `vis === null` — настройка ещё не загрузилась или недоступна (нет компании,
 * несколько компаний без выбора): показываем всё, как до фикса.
 */
export function pickVisibleSeasons<S extends SeasonLike>(
  seasons: readonly S[],
  vis: SeasonVisibilityWindow | null,
  nowYear: number,
  activeCode?: string | null,
): S[] {
  const desc = [...seasons].sort((a, b) => b.year - a.year);
  if (!vis) return desc;
  const from = nowYear - vis.past;
  const to = nowYear + vis.future;
  return desc.filter(
    (s) => (s.year >= from && s.year <= to) || (!!activeCode && s.code === activeCode),
  );
}
